import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import affiliateService from '../../Services/affiliateService';

/**
 * Higher-Order Component that tracks affiliate IDs across the entire application
 * Automatically detects and stores affiliate IDs from URL parameters
 */
const withAffiliateTracking = (WrappedComponent) => {
  class AffiliateTracker extends Component {
    componentDidMount() {
      this.trackAffiliateId();
    }

    componentDidUpdate(prevProps) {
      // Track affiliate ID when location changes
      if (prevProps.location.search !== this.props.location.search) {
        this.trackAffiliateId();
      }
    }

    trackAffiliateId = () => {
      const { location } = this.props;
      const affiliateId = affiliateService.extractAffiliateIdFromUrl(location.search);
      
      if (affiliateId) {
        affiliateService.storeAffiliateId(affiliateId);
        console.log('Affiliate ID detected and stored:', affiliateId);
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return withRouter(AffiliateTracker);
};

export default withAffiliateTracking;
